<div class="ai-panel">
    @if (header) {
        <div class="ai-panel-header">
            <ng-content select="ai-panel-header"></ng-content>
        </div>
    }

    <ng-content select="ai-breadcrumbs"></ng-content>

    <div class="ai-panel-content">
        <ng-content select="ai-panel-content"></ng-content>
    </div>

    <ng-content select="ai-panel-footer"></ng-content>
</div>
